const capabilities = [
  {
    label: 'VergeFS — Daha İyi Bir vSAN',
    href: 'https://www.verge.io/vergefs-a-better-vsan/',
    icon: 'ri-database-2-line',
    desc: 'Altyapı genelinde tekilleştirme ile depolama verimliliği.',
  },
  {
    label: 'ioMigrate — Sorunsuz Geçiş',
    href: 'https://www.verge.io/vmware-migrations-at-scale/',
    icon: 'ri-exchange-line',
    desc: 'Ortamınızdan büyük ölçekli geçişi kolaylaştırın.',
  },
  {
    label: 'VergeOS Sanal Veri Merkezleri',
    href: 'https://www.verge.io/vergeos-virtual-data-centers/',
    icon: 'ri-layout-grid-line',
    desc: 'Çok kiracılı izole sanal veri merkezleri oluşturun.',
  },
  {
    label: 'ioFortify — Fidye Yazılımı Dayanıklılığı',
    href: 'https://www.verge.io/iofortify/iofortify-landing-page/',
    icon: 'ri-shield-check-line',
    desc: 'Verilerinizi siber saldırılara karşı koruyun.',
  },
  {
    label: 'VergeIA — Yüksek Erişilebilirlik',
    href: 'https://www.verge.io/architecture/high-availability-data-protection-and-disaster-recovery/',
    icon: 'ri-server-line',
    desc: 'Kesintisiz operasyon için gerçek yüksek erişilebilirlik.',
  },
  {
    label: 'ioProtect —&nbsp; DR',
    href: 'https://www.verge.io/vmware-dr/ioprotect/',
    icon: 'ri-shield-star-line',
    desc: 'Olağanüstü durum kurtarma ve yedekleme çözümleri.',
  },
  {
    label: 'ioClone — Gelişmiş Anlık Görüntüler',
    href: 'https://www.verge.io/ioclone/',
    icon: 'ri-file-copy-line',
    desc: 'VM ve veri merkezlerini saniyeler içinde klonlayın.',
  },
  {
    label: 'ioGuardian — Donanım Dayanıklılığı',
    href: 'https://www.verge.io/ioguardian/',
    icon: 'ri-safe-line',
    desc: 'Donanım arızalarına karşı otomatik koruma.',
  },
];

export default function Capabilities() {
  return (
    <section className="w-full bg-[#f8f9fb] py-20 px-6">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-3xl font-bold text-[#1a1a2e] mb-3">VergeOS Yetenekleri</h2>
        <p className="text-[#64748b] text-base mb-10 max-w-2xl">
          Tek bir platformda birleştirilmiş güçlü özellikler — ihtiyacınız olan her şey burada.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {capabilities.map((cap) => (
            <a
              key={cap.label}
              href={cap.href}
              target="_blank"
              rel="nofollow noreferrer"
              className="bg-white rounded-xl p-5 border border-gray-100 hover:border-[#e8600a]/40 hover:shadow-sm transition-all group cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg mb-4 group-hover:bg-[#e8600a]/20 transition-colors">
                <i className={`${cap.icon} text-[#e8600a] text-lg`}></i>
              </span>
              <h3 className="text-sm font-semibold text-[#1a1a2e] mb-2 group-hover:text-[#e8600a] transition-colors leading-snug">
                {cap.label}
              </h3>
              <p className="text-xs text-[#64748b] leading-relaxed">{cap.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
